import React from "react";
import Layout from "../../Components/Global/Layout";
import BreadCrumb from '../../Components/Global/BreadCrumb/BreadCrumb';
import BlogCategoryAdd from '../../Components/BlogCategory/BlogCategoryAdd/BlogCategoryAdd'
import { useStore } from "../../Utils/utils"
import { select_store_message } from "../../Constants/Messages"
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

const BlogCategoryAddPage = () => {

     const navigate = useNavigate();
        const [storeName, setStoreName] = useState([]);
         const { store, setStore } = useStore();
    
         useEffect(() => {
                if (storeName?.length == 0 || storeName == undefined) {
                    setStoreName(() => [store?.name]);
                } else {
                    setStoreName((existingStoreId) => [...existingStoreId, store?.name]);
                }
            }, [store?.id]);
        
            useEffect(() => {
                if (storeName[1] != undefined) {
                    if (storeName[0] != storeName[1]) {
                        navigate("/admin");
                        setStoreName([]);
                    }
                }
            }, [storeName]);

    let select_store = store?.id == null || store?.id === undefined || store?.id === 0 || store?.name === "Global Admin" ? true : false
    return (
        <Layout>
            <div className="breadcrumb-wrapper breadcrumb-contacts">
                <div className="d-flex flex-column">
                    <BreadCrumb />
                </div>
            </div>
            {/* Create Blog Category */}
            {select_store ?
                <div className="card">
                    <div className="card-body  select_store">
                        <p className="text-center">{select_store_message?.select_store}</p>
                    </div>
                </div>
                :
                <BlogCategoryAdd />
            }
        </Layout >
    )
}
export default BlogCategoryAddPage;
